import Device from './device';
import User from './user';
import Diode from './diode';
import File from './file';


export default {
  Device,
  User,
  Diode,
  File
};
